import React, { useEffect, useRef } from "react";
import {
  Routes,
  //   MemoryRouter as Router,
  BrowserRouter as Router,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Application from "./pages/Application";
import Login from "./pages/login/login";
import { useCentralStore } from "./store/appContext";
import { AuthConsumer } from "./utils/authProvider";
import { isEmpty } from "./utils/functionUtils";
import ActionTypes from "./store/actionTypes";
import config from "./config/config";
import ErrorBoundary from "./ErrorBoundary";
import SmartStockContainer from "./pages/SmartStockContailer/SmartStockContainer";
import JobMonitoring from "../src/components/common/dataTable/JobMonitoringTable";

const ConsumedComponent = ({ Component }) => {
  return (
    <AuthConsumer>
      {({ signinRedirect, generateToken, signoutRedirectCallback }) => {
        return (
          <Component
            signinRedirect={signinRedirect}
            generateToken={generateToken}
            signoutRedirectCallback={signoutRedirectCallback}
          />
        );
      }}
    </AuthConsumer>
  );
};

const PrivateRoute = ({ Component }) => {
  const [{ userLoggedIn }, dispatch] = useCentralStore();
  let auth = useRef(userLoggedIn);

  const location = useLocation();

  useEffect(() => {
    if (userLoggedIn && !auth.current) {
      auth.current = true;
    }
  }, [userLoggedIn]);

  useEffect(() => {
    if (
      !isEmpty(location.search) &&
      location.search.startsWith("?code=") &&
      location.search.includes("&state=")
    ) {
      dispatch({
        type: ActionTypes.SET_AUTH_CODE_SEARCH,
        payload: location.search,
      });
    }
  }, [location]);

  // Remove code " || !config.isLocal " once we have SSO client Ids created for all envs
  return auth.current || !config.isLocal ? (
    // return auth.current ? (
    <AuthConsumer>
      {({ signinRedirect, generateToken, signoutRedirectCallback }) => {
        return (
          <Component
            signinRedirect={signinRedirect}
            generateToken={generateToken}
            signoutRedirectCallback={signoutRedirectCallback}
          />
        );
      }}
    </AuthConsumer>
  ) : (
    <Navigate to="/login" />
  );
};

const AllRoutes = () => {
  const [{ isApiError, userData, userDetails }] = useCentralStore();
  return (
    <ErrorBoundary isApiError={isApiError} userData={userData} userDetails={userDetails}>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={<ConsumedComponent Component={Login} />}
          />
          <Route
            path="/smartstock"
            element={<ConsumedComponent Component={SmartStockContainer} />}
          />
          <Route path="/" element={<PrivateRoute Component={Application} />} />
          <Route path="/job-monitoring" element={<JobMonitoring />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default AllRoutes;